import { IconCalculator, IconReceipt, IconTrendingUp } from '../../../common/icons';
import { fx } from '../utils/fx';

// Fase 2 — landing corta: qué es COWRE + por qué invertir, antes de la puja.
const BENEFITS = [
    { icon: <IconTrendingUp />, title: 'Valorización', text: 'El valor de tu vaca sube con avalúos fechados — como una acción.' },
    { icon: <IconCalculator />, title: 'Liquidación mensual', text: 'Cobras tu reparto del manejo cada mes según tu %.' },
    { icon: <IconReceipt />, title: 'Retorno por crías', text: 'Cada cría vendida de tu donadora suma a tu bolsillo.' },
];

export default function Landing({ onDone }) {
    const go = () => { fx.up(); onDone(); };
    return (
        <div className="evx__panel evx__land">
            <span className="evx__step">Estás dentro</span>
            <h2 className="evx__land-title">Eres socio de genética élite.</h2>
            <p className="evx__land-sub">
                Con COWRE compras un porcentaje de una donadora Cebú de alto valor y ves crecer tu inversión —
                demostrable, tuya y con retorno real.
            </p>

            <ul className="evx__land-benefits">
                {BENEFITS.map((b) => (
                    <li key={b.title} className="evx__land-benefit">
                        <span className="evx__land-icon">{b.icon}</span>
                        <div>
                            <span className="evx__land-benefit-title">{b.title}</span>
                            <span className="evx__land-benefit-text">{b.text}</span>
                        </div>
                    </li>
                ))}
            </ul>

            <button type="button" className="evx__cta evx__cta--big" onClick={go}>
                Estoy listo · ¡a pujar!
            </button>
        </div>
    );
}
